import { render, staticRenderFns } from "./orderDetailsPopUpBox.vue?vue&type=template&id=cf3012ec&scoped=true"
import script from "./orderDetailsPopUpBox.vue?vue&type=script&lang=js"
export * from "./orderDetailsPopUpBox.vue?vue&type=script&lang=js"
import style0 from "./orderDetailsPopUpBox.vue?vue&type=style&index=0&id=cf3012ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3012ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf3012ec')) {
      api.createRecord('cf3012ec', component.options)
    } else {
      api.reload('cf3012ec', component.options)
    }
    module.hot.accept("./orderDetailsPopUpBox.vue?vue&type=template&id=cf3012ec&scoped=true", function () {
      api.rerender('cf3012ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/orderDetailsPopUpBox.vue"
export default component.exports